import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import SideNavbar from "./SideNavbar";
import HeaderNav from "./HeaderNav";

export default function AccountsDashboardlayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Home");
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const handleMenuClick = (key) => {
    setActiveMenu(key);
    setMobileNavOpen(false);
  };


  const mobileMenuclick = () => {
    setMobileNavOpen(true);
    setCollapsed(false);
  };

  return (
    <div className="dashboard-section">
      {/* Sidebar */}
      <SideNavbar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        activeMenu={activeMenu}
        handleMenuClick={handleMenuClick}
        mobileNavOpen={mobileNavOpen}
        setMobileNavOpen={setMobileNavOpen}
      />

      {/* Main Area */}
      <div className="main-area">
        <HeaderNav mobileMenuclick={mobileMenuclick} />

        {/* Page Content */}
        <div className="p-3">
          <Outlet />
        </div>
      </div>
    </div >
  );
}
